import { AlertTriangle, ShieldAlert } from 'lucide-react'

interface Props {
  errors: string[]
  warnings: string[]
}

/** The graph checks: errors stop approval, warnings deserve a second look. */
export default function ChecksPanel({ errors, warnings }: Props) {
  if (!errors.length && !warnings.length) return null
  return (
    <div className='space-y-2' data-testid='world-graph-checks'>
      {errors.length > 0 && (
        <div className='rounded-md border border-red-200 bg-red-50 p-3 text-sm text-red-800'>
          <div className='mb-1 flex items-center gap-1.5 font-medium'>
            <ShieldAlert className='h-4 w-4' aria-hidden />
            Fix before approving
          </div>
          <ul className='list-disc space-y-0.5 pl-5'>
            {errors.map((error, index) => (
              <li key={index}>{error}</li>
            ))}
          </ul>
        </div>
      )}
      {warnings.length > 0 && (
        <div className='rounded-md border border-amber-200 bg-amber-50 p-3 text-sm text-amber-900'>
          <div className='mb-1 flex items-center gap-1.5 font-medium'>
            <AlertTriangle className='h-4 w-4' aria-hidden />
            Worth a look
          </div>
          <ul className='list-disc space-y-0.5 pl-5'>
            {warnings.map((warning, index) => (
              <li key={index}>{warning}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  )
}
